import axios from 'axios';

const API = (process.env.REACT_APP_BACKEND_URL || '') + '/api';

// In-memory access token. Survives across components in the same page load
// but is dropped on tab close — which is the secure pattern we want.
// (refresh_token is still in an httpOnly cookie for cross-session continuity.)
let _accessToken = null;

export const tokenStore = {
  get: () => _accessToken,
  set: (t) => { _accessToken = t || null; },
  clear: () => { _accessToken = null; },
};

const api = axios.create({ baseURL: API, withCredentials: true });

// Attach Authorization: Bearer <token> on every authenticated request when
// we have one in memory. This is the primary auth channel; the httpOnly
// cookies are a secondary channel that some browsers block on cross-site
// (third-party cookie blocking).
api.interceptors.request.use((config) => {
  if (_accessToken && !config.headers?.Authorization) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${_accessToken}`;
  }
  return config;
});

export default api;
